module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-tabbar', {
    attrs: {
      "fixed": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "index",
      "href": "#/"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('span', {
    staticClass: "iconfont icon-a01a"
  })]), _vm._v("\n    首页\n  ")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "list",
      "href": "#/list"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('span', {
    staticClass: "iconfont icon-zixunlist"
  })]), _vm._v("\n    列表页\n  ")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "account",
      "href": "#/account"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('span', {
    staticClass: "iconfont icon-iconfontweibiaoti1015"
  })]), _vm._v("\n    个人中心\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-25df0619!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 25
// module chunks = 0